import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DocumentTypeInternalRevenueBulletins } from './documenttypeinternalrevenuebulletins';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DocumenttypeinternalrevenuebulletinsService {

  baseUrl: string = environment.serviceUrl;

  constructor(private httpClient: HttpClient) {
  }

  Get(): Observable<DocumentTypeInternalRevenueBulletins[]> {
    return this.httpClient.get<DocumentTypeInternalRevenueBulletins[]>(this.baseUrl + 'api/DocumentTypeInternalRevenueBulletinsApi')
  }
  GetActive(): Observable<DocumentTypeInternalRevenueBulletins[]> {
    return this.httpClient.get<DocumentTypeInternalRevenueBulletins[]>(this.baseUrl + 'api/DocumentTypeInternalRevenueBulletinsApi/GetActiveDocumentTypeInternalRevenueBulletins')
  }
  Post(documenttypeinternalrevenuebulletins: DocumentTypeInternalRevenueBulletins): Observable<any> {

    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post(this.baseUrl + 'api/DocumentTypeInternalRevenueBulletinsApi/add', documenttypeinternalrevenuebulletins, { headers: header, observe: 'response' })
  }
  Delete(documenttypeinternalrevenuebulletins: DocumentTypeInternalRevenueBulletins) {
    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post(this.baseUrl + 'api/DocumentTypeInternalRevenueBulletinsApi/activeordeactive', documenttypeinternalrevenuebulletins, { headers: header, observe: 'response' })
  }
  Put(documenttypeinternalrevenuebulletins: DocumentTypeInternalRevenueBulletins): Observable<any> {
    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.put(this.baseUrl + 'api/DocumentTypeInternalRevenueBulletinsApi/Update', documenttypeinternalrevenuebulletins, { headers: header, observe: 'response' })
  }
}
